// @mui
import { Typography, Paper, Stack } from '@mui/material';
// hooks
import useResponsive from '../../../hooks/useResponsive';
// components
import Avatar from '../../../components/Avatar';


export default function SelectedPositionCard({ position }) {
  const smDown = useResponsive('down', 'sm');

  if (!position || !position.key || !position.value) return <></>;
  return (
    <Paper
      sx={{
        padding: { xs: 2, sm: 3 },
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
      }}
    >
      <Stack direction="row" alignItems="center" justifyContent={smDown ? "flex-start" : "center"} spacing={2}>
        <Avatar src={`https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/position/position_${position.key}.png`} />
        <Typography variant="h5" noWrap>
          {position.value}
        </Typography>
        <Typography variant="h5" sx={{ color: (theme) => theme.palette.text.secondary}}>
          찾아 드릴게요!
        </Typography>
      </Stack>
    </Paper>
  )
}